import { render, staticRenderFns } from "./PercentileIcon.vue?vue&type=template&id=483f9f8f&scoped=true"
import script from "./PercentileIcon.vue?vue&type=script&lang=js"
export * from "./PercentileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f9f8f",
  null
  
)

export default component.exports